<template>
  <div
    :class="{
      'fact-finder-categories-fi': true,
      'fact-finder-categories-fi--closed': !isMD && hideCategories,
      'fact-finder-categories-fi--app-view': isAppView,
    }"
  >
    <div
      class="fact-finder-categories-fi__label"
      @click="hideCategories = !hideCategories"
    >
      {{ $dict.get('product-List.Facets.Categories.Label') }}

      <icon-fi
        class="fact-finder-categories-fi__icon"
        icon="chevron-up"
      />
    </div>
    <div class="fact-finder-categories-fi__expander">
      <div class="fact-finder-categories-fi__inner">
        <div class="fact-finder-categories-fi__list">
          <fact-finder-category-fi
            v-for="category in categories"
            :key="category.id"
            :category="category"
            :filter-url-params="filterUrlParams"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { IconFi } from 'atoms';
import { ref } from 'vue';

import { useBreakpoints } from '@/composables/breakpoint';

import type { SearchFactFinderCategory } from '../SearchFactFinderResultsFi.vue';
import FactFinderCategoryFi from './fact-finder-category-fi/FactFinderCategoryFi.vue';

defineOptions({
  name: 'FactFinderCategoriesFi',
});

const { isMD } = useBreakpoints();

defineProps<{
  categories: SearchFactFinderCategory[];
  filterUrlParams?: string;
}>();

const hideCategories = ref(true);
</script>

<style scoped src="./fact-finder-categories-fi" />
